import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {MatPaginator} from "@angular/material/paginator";
import {HiperioRegistrationConfig} from "../../../shared/interface/hiperio-registration-config";
import {MatTableDataSource} from "@angular/material/table";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-hiperio-registration-config',
  templateUrl: './hiperio-registration-config.component.html',
  styleUrls: ['./hiperio-registration-config.component.scss']
})
export class HiperioRegistrationConfigComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  @Input() hiperioRegistrationConfigs: Observable<HiperioRegistrationConfig[]>;
  @Output() loadAffiliate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource: MatTableDataSource<HiperioRegistrationConfig>;
  userPermissions: ReplaySubject<UserPermissions>;
  displayedColumns: string[] = ['insuranceCompany', 'ofwca', 'ofwcaRegistration', 'company'];

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private affiliateCodeService: AffiliateCodeService,
    private snack: MatSnackBar,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.dataSource = new MatTableDataSource<HiperioRegistrationConfig>([]);
  }

  ngOnInit(): void {
    this.hiperioRegistrationConfigs
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((hiperioRegistrationConfig: HiperioRegistrationConfig[]) => this.dataSource.data = hiperioRegistrationConfig);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

}
